import { get, post } from "@/modules/request";
import { WriteResponse } from "@/types/api-types";
import { CrystalOrder, MateEquipment } from "@/types/entity";
import { ReceivedType } from "@/types/payment";

export const ApiGetCrystalPackage = (): Promise<{
  itemzz: {
    id: number;
    quantity: number;
    price: number;
  }[];
}> => get("/CrystalPackage");

export const ApiPostCrystalOrder = (
  packageId: number
): Promise<WriteResponse<{ uuid: string }>> =>
  post("/CrystalOrder", { packageId });

export const ApiPostCrystalOrderPay = (
  uuid: string,
  type: ReceivedType,
  amount: number
) => {
  const url = window.location.href.split("#")[0];
  return post(`/CrystalOrderPay/${uuid}`, {
    paymentMethod: 2,
    successUrl: `${url}#successPayment&${encodeURIComponent(
      JSON.stringify({
        list: [{ type, amount }],
        type: "CrystalOrderPay",
      })
    )}`,
    cancelUrl: `${url}#cancelPayment`,
  });
};
export const ApiPostCrystalTransactionBuyPower = (quantity: number) =>
  post(`/CrystalTransaction/BuyPower`, { quantity });

export const ApiPostUserPurchaseChest = (
  rarity: number
): Promise<WriteResponse<MateEquipment>> =>
  post(`/User/PurchaseChest`, { rarity });

export const ApiGetCrystalOrder = (
  uuid: string
): Promise<WriteResponse<CrystalOrder>> => get(`/CrystalOrder/${uuid}`);
